import React, {useEffect, useRef} from "react";
import { useGLTF } from "@react-three/drei";
import gsap from 'gsap'

const actionTypes = {
  NEXT_RADIO: 'NEXT_RADIO',
  PREVIOUS_RADIO: 'PREVIOUS_RADIO',
  UP_SOUND: 'UP_SOUND',
  DOWN_SOUND: 'DOWN_SOUND',
}

export default function Model(props) {
  const { nodes, materials } = useGLTF("/tv.glb");
  
  const powerButtonRef = useRef(null)
  const volumeDownButtonRef = useRef(null)
  const volumeUpButtonRef = useRef(null)
  const nextChannelButtonRef = useRef(null)
  const previousChannelButtonRef = useRef(null)
  const {getNextRadio, getPreviousRadio, upSound, downSound, setPower, isPower} = props

  const movePowerButton = (powerButtonRef) => {
    const tl = gsap.timeline();
    tl.to(powerButtonRef.current.position, { duration: 0.3, z: -0.083, onComplete: () => {
      setPower(!isPower)
    }})
    tl.to(powerButtonRef.current.position, { duration: 0.3, z: -0.085 })
  }
  
  const moveActionButtons = (actionButtonRef, actionType) => {
    const tl = gsap.timeline();
    tl.to(actionButtonRef.current.position, { duration: 0.3, z: -0.0848,
      onComplete: () => {
        if (!isPower) {
          return
        }
        switch (actionType) {
          case 'NEXT_RADIO':
            getNextRadio()
            break;
          case 'PREVIOUS_RADIO':
            getPreviousRadio()
            break;
          case 'UP_SOUND':
            upSound()
            break;
          case 'DOWN_SOUND':
            downSound()
            break;
        }
      }
    })
    tl.to(actionButtonRef.current.position, { duration: 0.3, z: -0.0865 })
  }
  
  const onPointerEnter = () => { document.body.style.cursor = 'pointer' }
  const onPointerLeave = () => { document.body.style.cursor = 'default' }

  return (
    <group {...props} dispose={null}>
      <mesh
        ref={powerButtonRef}
        onClick={() => movePowerButton(powerButtonRef)}
        onPointerEnter={ onPointerEnter }
        onPointerLeave={ onPointerLeave }
        geometry={nodes.Button_001.geometry}
        material={materials.TVfront}
        position={[0.114, 0.052, -0.086]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        ref={volumeDownButtonRef}
        onClick={() => moveActionButtons(volumeDownButtonRef, actionTypes.DOWN_SOUND)}
        onPointerEnter={ onPointerEnter }
        onPointerLeave={ onPointerLeave }
        geometry={nodes.Button_002.geometry}
        material={materials.TVfront}
        position={[0.099, 0.05, -0.0865]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        ref={volumeUpButtonRef}
        onClick={() => moveActionButtons(volumeUpButtonRef, actionTypes.UP_SOUND)}
        onPointerEnter={ onPointerEnter }
        onPointerLeave={ onPointerLeave }
        geometry={nodes.Button_003.geometry}
        material={materials.TVfront}
        position={[0.086, 0.05, -0.0865]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        ref={nextChannelButtonRef}
        onClick={() => moveActionButtons(nextChannelButtonRef, actionTypes.NEXT_RADIO)}
        onPointerEnter={ onPointerEnter }
        onPointerLeave={ onPointerLeave }
        geometry={nodes.Button_004.geometry}
        material={materials.TVfront}
        position={[0.074, 0.05, -0.0865]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        ref={previousChannelButtonRef}
        onClick={() => moveActionButtons(previousChannelButtonRef, actionTypes.PREVIOUS_RADIO)}
        onPointerEnter={ onPointerEnter }
        onPointerLeave={ onPointerLeave }
        geometry={nodes.Button_005.geometry}
        material={materials.TVfront}
        position={[0.061, 0.05, -0.0865]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.defaultMaterial.geometry}
        material={materials.TVback}
        position={[-0.026, 0.127, 0.131]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.defaultMaterial001.geometry}
        material={materials.TVfront}
        position={[-0.008, 0.165, -0.038]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.defaultMaterial004.geometry}
        material={materials.TVfront}
        position={[-0.032, 0.068, 0.107]}
        rotation={[Math.PI, 0, 2.546]}
        scale={[0.004, 0.004, 0.002]}
      />
      <mesh
        geometry={nodes.defaultMaterial005.geometry}
        material={materials.TVfront}
        position={[-0.07, 0.053, -0.082]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.defaultMaterial006.geometry}
        material={materials.TVfront}
        position={[-0.04, 0.058, 0.113]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.defaultMaterial007.geometry}
        material={materials.TVfront}
        position={[-0.141, 0.078, 0.104]}
        rotation={[Math.PI / 2, -1.57, 0]}
        scale={0.002}
      />
      <mesh
        geometry={nodes.defaultMaterial008.geometry}
        material={materials.TVfront}
        position={[0, 0.082, -0.088]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={0.001}
      />
      <mesh
        geometry={nodes.Screen.geometry}
        material={materials.TVScreen}
        position={[0, 0.268, -0.075]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={3.982}
      />
    </group>
  );
}

useGLTF.preload("/tv.glb");
